import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Switch, Route, useHistory, useLocation, Redirect } from 'react-router';
import Header from '../../components/Header';
import { Drawer, List, ListItemIcon, ListItem, Divider, ListItemText, Toolbar, Theme, createStyles, makeStyles, Hidden, Container } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home'
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ForumIcon from '@material-ui/icons/Forum';
import SendIcon from '@material-ui/icons/Send';
import Coach from '../../page/admin/Coach';
import User from '../../page/admin/User';
import Home from '../../page/admin/Home';
import Orders from '../../page/admin/Orders';
import Initialinterview from '../../page/admin/InitialInterview';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import { CourseIcon, CoachIcon, ChannelIcon, CoachCampIcon } from '../../components/Icons';
import Course from '../../page/admin/Course';
import AddCourse from '../../page/admin/AddCourse';
import AddCollection from '../../page/admin/AddCollection';
import ShareIcon from '@material-ui/icons/Share';
import SortCourse from '../../page/admin/SortCourse';
import SalesChannel from '../../page/admin/SalesChannel';
import CoachCamp from './CoachCamp';
import CreateCoachCamp from './CoachCamp/Create';
import Clients from './Clients';
import Push from './Push';
import ShareManage from './Share';
const router = [
    {
        name: '首页',
        path: '/admin/home',
        icon: <HomeIcon />,
        component: <Home />
    },
    {
        name: '用户管理',
        path: '/admin/user',
        icon: <AccountCircleIcon />,
        component: <User />
    },
    {   
        name: '来访者管理',
        path: '/admin/clients',
        icon: <PermContactCalendarIcon />,
        component: <Clients />
    },
    {
        name: '渠道管理',
        path: '/admin/channel',
        icon: <ChannelIcon />,
        component: <SalesChannel />
    },
    {
        name: '首次约谈',
        path: '/admin/initialinterview',
        icon: <ForumIcon />,
        component: <Initialinterview />
    },
    {
        name: '教练管理',
        path: '/admin/coach',
        icon: <CoachIcon />,
        component: <Coach />
    },
    {
        name: '训练营管理',
        path: '/admin/coach-camp',
        icon: <CoachCampIcon style={{fontSize: '22px'}} />,
        component: <CoachCamp />
    },
    {
        name: '课程管理',
        path: '/admin/course',
        icon: <CourseIcon />,
        component: <Course />
    },
    {
        name: '推送管理',
        path: '/admin/push',
        icon: <SendIcon />,
        component: <Push />
    },
    {
        name: '分享管理',
        path: '/admin/share',
        icon: <ShareIcon />,
        component: <ShareManage />
    },
    {
        name: '订单管理',
        path: '/admin/orders',
        icon: <AssignmentIcon />,
        component: <Orders />
    }
]

const drawerWidth = 180;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawerPaper: {
            width: drawerWidth,
        },
        drawerContainer: {
            overflow: 'auto',
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: theme.spacing(5) + 1,
            [theme.breakpoints.up('sm')]: {
                width: theme.spacing(7) + 1,
            },
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(2),
                width: '100vw',
                boxSizing: 'border-box'
            }
        }
    }),
);

function App() {
    const classes = useStyles()
    const history = useHistory()
    const location = useLocation()
    const [showDrawer, setShowDrawer] = useState(true)
    const [openDrawer, setOpenDrawer] = useState(false)
    const handleDrawerClick = (path: string | string[]) => () => {
        let to = path
        if (typeof path === 'object') {
            to = path[0]
        }
        setOpenDrawer(false);
        history.replace(to + '?refresh=' + new Date().getTime())
    }
    const [userType] = useState(() => localStorage.getItem('user'))
    useEffect(() => {
        if (userType !== 'admin') {
            history.replace(`/${userType}/home`)
        }
    }, [userType])

    const handleDrawerToggle = () => {
        setOpenDrawer(!openDrawer);
    };

    const drawer = () => {
        return <React.Fragment>
            <Toolbar />
            <div className={classes.drawerContainer}>
                <List>
                    {router.map((route, index) => (
                        <ListItem selected={route.path === location.pathname} onClick={handleDrawerClick(route.path)} button key={route.path.toString()}>
                            <ListItemIcon>{route.icon}</ListItemIcon>
                            <ListItemText primary={route.name} />
                        </ListItem>
                    ))}
                </List>
                <Divider />
            </div>
        </React.Fragment>
    }

    return (
        <div className={classes.root}>
            <Header title={'管理员后台'} showMenu={showDrawer} onMenuClick={handleDrawerToggle} position="fixed" className={classes.appBar} />
            <Hidden xsDown implementation="css">
                <Drawer
                    variant="permanent"
                    open={openDrawer}
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: openDrawer,
                        [classes.drawerClose]: !openDrawer,
                    })}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: openDrawer,
                            [classes.drawerClose]: !openDrawer,
                        }),
                    }}>
                    {drawer()}
                </Drawer>
            </Hidden>

            <Hidden smUp implementation="css">
                <Drawer
                    variant="temporary"
                    open={openDrawer}
                    onClose={() => setOpenDrawer(false)}
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: openDrawer,
                        [classes.drawerClose]: !openDrawer,
                    })}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: openDrawer,
                            [classes.drawerClose]: !openDrawer,
                        }),
                    }}>
                    {drawer()}
                </Drawer>
            </Hidden>

            <main className={classes.content}>
                <Toolbar />
                <Switch>
                    {router.map((route, index) => (
                        <Route path={route.path} key={route.path} exact>
                            {route.component}
                        </Route>
                    ))}
                    <Route path="/admin/course/add" exact>
                        <AddCourse />
                    </Route>
                    <Route path="/admin/coach-camp/create" exact>
                        <CreateCoachCamp />
                    </Route> 
                    <Route path="/admin/coach-camp/edit/:campId" exact>
                        <CreateCoachCamp />
                    </Route>
                    <Route path="/admin/course/edit/:courseId" exact>
                        <AddCourse />
                    </Route>
                    <Route path="/admin/collection/add" exact>
                        <AddCollection />
                    </Route>
                    <Route path="/admin/collection/edit/:collectionId" exact>
                        <AddCollection />
                    </Route>
                    <Route path="/admin/course/sort/:courseId" exact>
                        <SortCourse />
                    </Route>
                    <Route path="*">
                        <Home />
                    </Route>
                </Switch>
            </main>
        </div>
    );
}

export default App;
